import React from "react";
const RoleContext = React.createContext({
  token: false,
  role: null,
});

export const RoleProvider = RoleContext.Provider;
export const RoleConsumer = RoleContext.Consumer;
export default RoleContext;
